export default __webpack_public_path__ + "static/media/theworldbank.138d86f3.png";